// import Tools from '@/modules/core/events/Services'

export default ([
    // {
    //     path: '/tools',
    //     name: 'ToolsPay',
    //     component: Tools,
    //     meta: {
    //         breadcrumb: 'Сервисы',
    //     }
    // },

])


